import { createSelector } from '@ngrx/store';

import { paymentState } from '../root';

export const isPaymentComplete = createSelector(
    paymentState,
    payment => payment.paymentStepStatus === 'complete'
);
